import { render } from "./Dashboard.vue?vue&type=template&id=3ac1a7e6"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=3ac1a7e6&lang=scss"
script.render = render

export default script